import { Button, Checkbox, Form, Input } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/admin-logo.svg";
import LoginLayout from "../../../layouts/LoginLayout";

export default function Login() {
  const [form] = Form.useForm();
  const [keep, setKeep] = useState(true);

  const onFinish = (values: any) => {};

  return (
    <LoginLayout
      title="Login"
      logo={Logo}
      loginImage="/assets/admin-login.svg"
      childrenClass="bg-primary relative"
    >
      <img
        src="/assets/up-icon.svg"
        className="absolute top-0 left-6 h-24"
        alt=""
      />
      <img
        src="/assets/down-icon.svg"
        className="absolute bottom-0 right-8 h-52 "
        alt=""
      />
      <div className="min-w-[350px] admin-login">
        <h3 className="text-4xl font-semibold text-white">Login</h3>
        <p className="text-lg font-normal text-[#FFFFFFB2] mt-1.5 mb-[30px]">
          I’am a organizer
        </p>

        <Form
          className="custom-form"
          layout="vertical"
          // requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <Form.Item
            name="email"
            className="mb-6"
            rules={[
              {
                required: true,
                message: "Please enter email",
              },
            ]}
          >
            <Input
              className="!bg-transparent !border-white !text-white placeholder:!text-white"
              placeholder="Email address"
            />
          </Form.Item>
          <Form.Item
            name="password"
            className="mb-6"
            rules={[
              {
                required: true,
                message: "Please enter password",
              },
            ]}
          >
            <Input.Password
              className="!bg-transparent !border-white !text-white"
              placeholder="Password"
            />
          </Form.Item>

          <div className="w-full mb-[30px]">
            <Checkbox
              className="!select-none !font-medium text-[#FFFFFFB2]"
              checked={keep}
              onChange={(e) => setKeep(e.target.checked)}
            >
              Keep me logged in
            </Checkbox>
          </div>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            //   loading={isLoading}
            block
            className="!bg-white !text-primary !font-medium
"
          >
            Log In
          </Button>

          <div className="mt-4 flex justify-center text-center">
            <Link
              to=""
              //   to="/forgot-password"
              className="hover:underline !select-none !text-[#FFFFFFB2] !font-medium"
            >
              Forgot password?
            </Link>
          </div>
        </Form>
      </div>
    </LoginLayout>
  );
}
